import ReactGA from 'react-ga4';

// Initialize Google Analytics with your measurement ID
export const initGA = (): void => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize('G-GK27H8GXQ3');
  } else {
    console.log('Google Analytics initialized in development mode');
  }
};

// Track page views
export const trackPageView = (page: string): void => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.send({ hitType: 'pageview', page });
  } else {
    console.log(`Page view tracked: ${page}`);
  }
};

// Track custom events
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
): void => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  } else {
    console.log(`Event tracked: ${category} - ${action}${label ? ` - ${label}` : ''}${value !== undefined ? ` (${value})` : ''}`);
  }
};

// Upgrade funnel tracking
export const trackUpgradeFunnel = {
  buttonClick: (source: 'navbar' | 'feature_gate' | 'settings') => {
    trackEvent('Upgrade', 'button_click', source);
  },
  modalView: () => {
    trackEvent('Upgrade', 'modal_view');
  },
  modalCtaClick: () => {
    trackEvent('Upgrade', 'modal_cta_click');
  },
  modalDismiss: () => {
    trackEvent('Upgrade', 'modal_dismiss');
  },
  checkoutRedirect: (source: string) => {
    trackEvent('Upgrade', 'checkout_redirect', source);
  },
};